import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { useTheme } from '@mui/material/styles';

export default function SegmentedLinearProgress({ segments = [], height = 6, radius = 4 }) {
    const theme = useTheme();

    const getColor = (key) => {
        if (theme.palette[key]?.main) return theme.palette[key].main;
        if (key === 'inherit') return theme.palette.text.primary;
        if (key === 'grey') return theme.palette.grey[500];
        return key;
    };

    const normalized = segments
        .filter((s) => s && s.value > 0)
        .map((s) => ({ ...s, value: Math.min(Math.max(s.value, 0), 100) }));

    const total = normalized.reduce((acc, s) => acc + s.value, 0);
    const clipped = total > 100 ? normalized.map((s) => ({ ...s, value: (s.value / total) * 100 })) : normalized;

    return (
        <Box
            role="progressbar"
            aria-valuemin={0}
            aria-valuemax={100}
            aria-label="segmented linear progress"
            sx={{
                width: '100%',
                height: '4px',
                borderRadius: radius,
                overflow: 'hidden',
                backgroundColor: theme.palette.grey[300],
                display: 'flex',
                gap: '8px',
            }}
        >
            {clipped.map((seg, idx) => (
                <Tooltip key={idx} title={seg.label || `${Math.round(seg.value)}%`}>
                    <Box
                        sx={{
                            width: `${seg.value}%`,
                            height: '100%',
                            backgroundColor: getColor(seg.color),
                        }}
                    />
                </Tooltip>
            ))}
        </Box>
    );
}
